import { formatDate, formatTime } from "../../helpers/dateFormatter";
import React from 'react';
import { DIMENSIONS } from "utils/Dimensions";
import { DiAsterisk } from "react-icons/di";
import ReactDOMServer from 'react-dom/server';

export default function DateColumnRenderer(params) {
  const columnOptions =
    params.columnTypeId == "19" || params.columnTypeId == "7"
      ? typeof params.columnOptions?.formula_column?.options == "object"
        ? params.columnOptions?.formula_column?.options
        : JSON.parse(params.columnOptions?.formula_column?.options)[0]
      : params.columnOptions,
    value = params.value;
  const columnTypeId =
    params.columnTypeId == "19" || params.columnTypeId == "7"
      ? params.columnOptions.formula_column.column_type_id
      : params.columnTypeId;
  let highlightIconColor = "";
  let highlightDuplicates = false;
  const cellValue = (params.value && params.value.match(/^\d{4}-\d{2}-\d{2}$/) && (params.value !== "0000-00-00" && params.value !== "0000-00-00 00:00:00")) ? params.value + " 00:00:00" : params.value;
  if(!params?.store?.isSubsheet && params.colDef?.cellRendererParams?.columnOptions?.is_highlighted && params.value !== '' && params.value !== '0000-00-00' && params.value !== '0000-00-00 00:00:00' && (params.store.duplicateColumnsData[params.colDef.dataIndex] && params.store.duplicateColumnsData[params.colDef.dataIndex][cellValue] && params.store.duplicateColumnsData[params.colDef.dataIndex][cellValue]>1)){
    highlightDuplicates = true;
    highlightIconColor = params.store.duplicateColumnsData['themeColor'] ? params.store.duplicateColumnsData['themeColor'] : '';
  }

  if(params?.store?.isSubsheet && params.colDef?.cellRendererParams?.columnOptions?.is_highlighted && params.value !== '' && params.value !== '0000-00-00' && params.value !== '0000-00-00 00:00:00' && (params.store.duplicateColumnsData[params.colDef.dataIndex + '_' + params?.store.parentRowId] && params.store.duplicateColumnsData[params.colDef.dataIndex + '_' + params?.store.parentRowId][cellValue] && params.store.duplicateColumnsData[params.colDef.dataIndex + '_' + params?.store.parentRowId][cellValue]>1)){
    highlightDuplicates = true;
    highlightIconColor = params.store.duplicateColumnsData['themeColor'] ? params.store.duplicateColumnsData['themeColor'] : '';
  }

  const highlightIcon = ReactDOMServer.renderToStaticMarkup(
    <DiAsterisk style={{
      position: 'absolute',
      top: '5px',
      right: '5px',
      fontSize: '20px'
    }}
    className='highlightIcon'
    color = {highlightIconColor} />
  );

  return (
    `<div
      class="dateColumn"
      style="line-height: ${
        params.node.rowHeight <= DIMENSIONS.cell_height_compact ? "normal" : ""
      };"
    >
      ${highlightDuplicates ? highlightIcon : ''}
      ${formatDate(value, "YYYY-MM-DD", columnOptions ? columnOptions["format"] : (columnTypeId == "4" ? "M j, Y" : "M j, Y g:iA"))}&nbsp;
      ${formatTime(value, columnTypeId)}
    </div>`
  );
}
